module.exports = __webpack_public_path__ + "static/homepage-hero-tvc-portrait-540w-ad544b9949bb43a5ce8136922c900057.jpg";